export enum LobbyErrorCode {
    Unknown = 'Unknown',
    InvalidExternalId = 'InvalidExternalId',
    InvalidAggregateVersion = 'InvalidAggregateVersion',
    EntityNotFound = 'EntityNotFound',
    AuthorizationContextEmpty = 'AuthorizationContextEmpty',
    AuthorizationContextRootUserCannotBeDropped = 'AuthorizationContextRootUserCannotBeDropped',
    BusinessSectorNotFound = 'BusinessSectorNotFound',
    BusinessSectorAtecoCodeInvalid = 'BusinessSectorAtecoCodeInvalid',
    BusinessSectorAlreadyDeleted = 'BusinessSectorAlreadyDeleted',
    BusinessSectorIsNotDeleted = 'BusinessSectorIsNotDeleted',
    DateTimeInThePast = 'DateTimeInThePast',
    DateTimeInTheFuture = 'DateTimeInTheFuture',
    PartitaIvaInvalid = 'PartitaIvaInvalid',
    CodiceFiscalePersonaFisicaInvalid = 'CodiceFiscalePersonaFisicaInvalid',
    CodiceFiscalePersonaGiuridicaInvalid = 'CodiceFiscalePersonaGiuridicaInvalid',
    PhoneNumberInvalid = 'PhoneNumberInvalid',
    PhoneNumberInvalidPrefix = 'PhoneNumberInvalidPrefix',
    EmailInvalid = 'EmailInvalid',
    AppKeyInvalid = 'AppKeyInvalid',
    DescriptionInvalid = 'DescriptionInvalid',
    TextInvalid = 'TextInvalid',
    TimeIntervalInvalid = 'TimeIntervalInvalid',
    RegioneNotFound = 'RegioneNotFound',
    ProvinciaNotFound = 'ProvinciaNotFound',
    ComuneNotFound = 'ComuneNotFound',
    LeadInvalidId = 'LeadInvalidId',
    LeadNotFound = 'LeadNotFound',
    LeadCannotBePreprocessed = 'LeadCannotBePreprocessed',
    LeadCannotBeAutoOffered = 'LeadCannotBeAutoOffered',
    LeadNotQualifiable = 'LeadNotQualifiable',
    LeadAlreadyProcessed = 'LeadAlreadyProcessed',
    LeadAlreadyAssigned = 'LeadAlreadyAssigned',
    LeadAlreadyOffered = 'LeadAlreadyOffered',
    LeadIsNotAssignable = 'LeadIsNotAssignable',
    LeadNotOffered = 'LeadNotOffered',
    LeadNotAssigned = 'LeadNotAssigned',
    LeadAssignationMissing = 'LeadAssignationMissing',
    LeadOffereeMismatch = 'LeadOffereeMismatch',
    LeadAssignationClosed = 'LeadAssignationClosed',
    LeadAssignationStatusInvalid = 'LeadAssignationStatusInvalid',
    LeadAssigneeMismatch = 'LeadAssigneeMismatch',
    LeadQualificationStatusNotFinal = 'LeadQualificationStatusNotFinal',
    LeadAssignatorMismatch = 'LeadAssignatorMismatch',
    LeadInjectorNotFound = 'LeadInjectorNotFound',
    LeadInjectorNotActive = 'LeadInjectorNotActive',
    LeadInjectorDisabled = 'LeadInjectorDisabled',
    LeadFiscalIdNotFound = 'LeadFiscalIdNotFound',
    LeadFiscalIdDuplicate = 'LeadFiscalIdDuplicate',
    LeadPartitaIvaNotFound = 'LeadPartitaIvaNotFound',
    LeadCfPersonaFisicaNotFound = 'LeadCfPersonaFisicaNotFound',
    LeadCfPersonaGiuridicaNotFound = 'LeadCfPersonaGiuridicaNotFound',
    LeadContactPointNotFound = 'LeadContactPointNotFound',
    LeadAssignationOfferNotFound = 'LeadAssignationOfferNotFound',
    LeadAssignationNotFound = 'LeadAssignationNotFound',
    LeadContactPointDuplicate = 'LeadContactPointDuplicate',
    RawValueNotFound = 'RawValueNotFound',
    RawValueInvalid = 'RawValueInvalid',
    QualificationOutcomeInvalid = 'QualificationOutcomeInvalid',
    LeadQualificationOutcomeInvalid = 'LeadQualificationOutcomeInvalid',
    MissingAggregateVersion = 'MissingAggregateVersion',
    OutOfRange = 'OutOfRange',
    InvalidLogic = 'InvalidLogic',
    InvalidStateTransition = 'InvalidStateTransition',
    EnumNameUnrecognized = 'EnumNameUnrecognized',
    NumberNonPositive = 'NumberNonPositive',
    NumberNegative = 'NumberNegative',
    NumberNonNegative = 'NumberNonNegative',
    NumberPositive = 'NumberPositive',
    NumberOutOfRange = 'NumberOutOfRange',
    PortoServiceError = 'PortoServiceError',
    PortoUserNotFound = 'PortoUserNotFound',
    PortoUserAlreadyProjected = 'PortoUserAlreadyProjected',
    PortoUserNotInHierarchy = 'PortoUserNotInHierarchy',
    SortingCriteriaMissing = 'SortingCriteriaMissing',
    SortingComponentUnrecognized = 'SortingComponentUnrecognized',
    ViewNameUnrecognized = 'ViewNameUnrecognized',
    FilterUnrecognized = 'FilterUnrecognized',
    StringIsEmpty = 'StringIsEmpty',
    InvalidUri = 'InvalidUri',
    UserInactive = 'UserInactive',
    UserNotFound = 'UserNotFound',
    UserPropertyUnknown = 'UserPropertyUnknown',
    UserPropertyNotFound = 'UserPropertyNotFound',
    UserPropertyInvalid = 'UserPropertyInvalid',
    UserPropertyDuplicate = 'UserPropertyDuplicate',
    UserPermissionNotGrantable = 'UserPermissionNotGrantable',
    UserNotAuthenticated = 'UserNotAuthenticated',
    UserForbidden = 'UserForbidden',
    UserPermissionAlreadyGranted = 'UserPermissionAlreadyGranted',
    UserPermissionNotGranted = 'UserPermissionNotGranted',
    UserPermissionGrantSelf = 'UserPermissionGrantSelf',
    UserPermissionRevokeSelf = 'UserPermissionRevokeSelf',
    UserPermissionUnknown = 'UserPermissionUnknown',
    UserInterdictionNotFound = 'UserInterdictionNotFound',
    MediaEmpty = 'MediaEmpty',
    MediaTypeUnsupported = 'MediaTypeUnsupported',
    MediaSizeTooLarge = 'MediaSizeTooLarge',
    MediaSizeTooSmall = 'MediaSizeTooSmall',
    MediaParseError = 'MediaParseError'
}

export const permissionLobbyErrorCodes = [
    LobbyErrorCode.UserForbidden,
    LobbyErrorCode.UserNotAuthenticated,
    LobbyErrorCode.UserPermissionNotGrantable,
    LobbyErrorCode.PortoUserNotInHierarchy,
    LobbyErrorCode.UserPermissionGrantSelf,
    LobbyErrorCode.UserPermissionRevokeSelf
]

export const invalidOperationLobbyErrorCodes = [
    LobbyErrorCode.UserPermissionUnknown,
    LobbyErrorCode.UserPermissionRevokeSelf,
    LobbyErrorCode.UserPermissionNotGranted,
    LobbyErrorCode.UserPermissionAlreadyGranted,
    LobbyErrorCode.UserPermissionNotGrantable,
    LobbyErrorCode.UserPropertyDuplicate,
    LobbyErrorCode.UserPropertyInvalid,
    LobbyErrorCode.UserPropertyNotFound,
    LobbyErrorCode.UserPropertyUnknown,
    LobbyErrorCode.UserNotFound,
    LobbyErrorCode.UserInactive,
    LobbyErrorCode.InvalidUri,
    LobbyErrorCode.StringIsEmpty,
    LobbyErrorCode.PortoUserNotInHierarchy,
    LobbyErrorCode.PortoUserAlreadyProjected,
    LobbyErrorCode.PortoUserNotFound,
    LobbyErrorCode.NumberOutOfRange,
    LobbyErrorCode.NumberPositive,
    LobbyErrorCode.NumberNegative,
    LobbyErrorCode.NumberNonPositive,
    LobbyErrorCode.InvalidLogic,
    LobbyErrorCode.OutOfRange,
    LobbyErrorCode.LeadQualificationOutcomeInvalid,
    LobbyErrorCode.QualificationOutcomeInvalid,
    LobbyErrorCode.RawValueNotFound,
    LobbyErrorCode.LeadContactPointDuplicate,
    LobbyErrorCode.LeadAssignationNotFound,
    LobbyErrorCode.LeadAssignationOfferNotFound,
    LobbyErrorCode.LeadContactPointNotFound,
    LobbyErrorCode.LeadCfPersonaGiuridicaNotFound,
    LobbyErrorCode.LeadCfPersonaFisicaNotFound,
    LobbyErrorCode.LeadCannotBePreprocessed,
    LobbyErrorCode.LeadCannotBeAutoOffered,
    LobbyErrorCode.LeadNotQualifiable,
    LobbyErrorCode.LeadAlreadyProcessed,
    LobbyErrorCode.LeadAlreadyAssigned,
    LobbyErrorCode.LeadAlreadyOffered,
    LobbyErrorCode.LeadIsNotAssignable,
    LobbyErrorCode.LeadNotOffered,
    LobbyErrorCode.LeadNotAssigned,
    LobbyErrorCode.LeadAssignationMissing,
    LobbyErrorCode.LeadOffereeMismatch,
    LobbyErrorCode.LeadAssignationClosed,
    LobbyErrorCode.LeadAssignationStatusInvalid,
    LobbyErrorCode.LeadAssigneeMismatch,
    LobbyErrorCode.LeadQualificationStatusNotFinal,
    LobbyErrorCode.LeadAssignatorMismatch,
    LobbyErrorCode.LeadInjectorNotFound,
    LobbyErrorCode.LeadInjectorNotActive,
    LobbyErrorCode.LeadInjectorDisabled,
    LobbyErrorCode.LeadFiscalIdNotFound,
    LobbyErrorCode.LeadFiscalIdDuplicate,
    LobbyErrorCode.LeadPartitaIvaNotFound,
    LobbyErrorCode.InvalidExternalId,
    LobbyErrorCode.AuthorizationContextEmpty,
    LobbyErrorCode.AuthorizationContextEmpty,
    LobbyErrorCode.AuthorizationContextRootUserCannotBeDropped,
    LobbyErrorCode.BusinessSectorNotFound,
    LobbyErrorCode.BusinessSectorAtecoCodeInvalid,
    LobbyErrorCode.BusinessSectorAlreadyDeleted,
    LobbyErrorCode.BusinessSectorIsNotDeleted,
    LobbyErrorCode.DateTimeInThePast,
    LobbyErrorCode.DateTimeInTheFuture,
    LobbyErrorCode.PartitaIvaInvalid,
    LobbyErrorCode.CodiceFiscalePersonaFisicaInvalid,
    LobbyErrorCode.CodiceFiscalePersonaGiuridicaInvalid,
    LobbyErrorCode.PhoneNumberInvalid,
    LobbyErrorCode.PhoneNumberInvalidPrefix,
    LobbyErrorCode.EmailInvalid,
    LobbyErrorCode.AppKeyInvalid,
    LobbyErrorCode.DescriptionInvalid,
    LobbyErrorCode.TextInvalid,
    LobbyErrorCode.TimeIntervalInvalid,
    LobbyErrorCode.RegioneNotFound,
    LobbyErrorCode.ProvinciaNotFound,
    LobbyErrorCode.ComuneNotFound,
    LobbyErrorCode.LeadInvalidId,
]